// import React, { useEffect, useState } from 'react';
// import { Container, Row, Col } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import { fetch } from '../../utils';
// const CategoryComponent = () => {
//     const [categoryList, setCategoryList] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const getCategryList = async () => {
//         try {
//             const response = await fetch("/category/hierarchy", "get", null, null);
//             setCategoryList(response.data.data.category);
//         } catch (err) {
//             console.log(err);
//         } finally {
//             setLoading(false);
//         }
//     };
//     useEffect(() => {
//         getCategryList();
//     }, []);

//     return (        
//         <Container>
//             <Row>
//                 {loading
//                     ? Array.from({ length: 6 }).map((_, index) => (
//                         <div key={index} className='col-lg-2 col-sm-3 col-4'>
//                             <div className='skeleton2'>
//                                 <div className='skeleton-image2'></div>
//                                 <div className='skeleton-text2'></div>
//                             </div>
//                         </div>
//                     )) : categoryList.length > 0 ? (
//                         categoryList.map((category, index) => (
//                             <div key={index} className='col-lg-2 col-sm-3 col-4'>
//                                 <CategoryItem category={category}  />
//                             </div>
//                         ))
//                     ) : (
//                         <h5 className='text-center my-5 text-danger'>No products found</h5>
//                     )}
//             </Row>
//         </Container>
//     );
// };

// const CategoryItem = ({ category }) => {
//     const [imageLoaded, setImageLoaded] = useState(false);
//     return (
//         <div className="product-item">
//             <Link to={`/${category.category_slug}`}>
//                 <div className="image-box">
//                     {!imageLoaded && <div className='skeleton-image2'></div>}
//                     <img
//                     width="370" height="370"
//                         src={category.category_thumbnail}
//                         alt={`Traditional` + " " + category.category_name + " " + `Collection`}                                       
//                         className={`w-100 img-fluid ${imageLoaded ? '' : 'd-none'}`}
//                         onLoad={() => setImageLoaded(true)}                        
//                     />
//                 </div>
//                 <p className='text-center cate-p pt-2 text-capitalize'>{category.category_name}</p>
//             </Link>
//         </div>
//     );
// };

// export default CategoryComponent;



import React, { useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { fetch } from '../../utils';

const CategoryComponent = () => {
    const [categoryList, setCategoryList] = useState([]);
    const [loading, setLoading] = useState(true);

    const getCategryList = async () => {
        try {
            const response = await fetch('/category/hierarchy', 'get', null, null);
            setCategoryList(response?.data?.data?.category || []);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { getCategryList() }, []);

    return (
        <>
            <style>{`
    .category-section{padding:45px 0 25px}
    .category-head{text-align:center;margin-bottom:30px}
    .category-head .small-title{font-size:12px;letter-spacing:3px;text-transform:uppercase;color:#999;font-weight:600;margin-bottom:7px}
    .category-head h2{font-size:28px;font-weight:700;color:#222;margin:0}
    .category-head p{font-size:14px;color:#777;margin:8px 0 0}
    .category-card{display:block;text-decoration:none;color:inherit}
    .category-image-box{position:relative;overflow:hidden;border-radius:14px;background:#f7f7f7;aspect-ratio:1/1;box-shadow:0 3px 15px rgba(0,0,0,.06);transition:.35s}
    .category-image-box img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .5s ease}
    .category-card:hover .category-image-box{box-shadow:0 10px 28px rgba(0,0,0,.13);transform:translateY(-3px)}
    .category-card:hover .category-image-box img{transform:scale(1.06)}
    .category-overlay{position:absolute;inset:0;background:linear-gradient(to top,rgba(0,0,0,.38),transparent 45%);opacity:0;transition:.35s}
    .category-card:hover .category-overlay{opacity:1}
    .category-name{font-size:15px;font-weight:600;color:#222;text-align:center;margin:13px 0 0;text-transform:capitalize;transition:.3s}
    .category-card:hover .category-name{color:#b07a35}
    .category-arrow{font-size:12px;margin-left:5px;opacity:0;transform:translateX(-5px);display:inline-block;transition:.3s}
    .category-card:hover .category-arrow{opacity:1;transform:translateX(0)}
    .category-skeleton{border-radius:14px;background:#f5f5f5;overflow:hidden}
    .category-skeleton-img{aspect-ratio:1/1;background:linear-gradient(90deg,#f1f1f1 25%,#e8e8e8 37%,#f1f1f1 63%);background-size:400% 100%;animation:categoryShimmer 1.4s infinite}
    .category-skeleton-text{height:14px;width:65%;margin:13px auto 4px;border-radius:10px;background:linear-gradient(90deg,#f1f1f1 25%,#e8e8e8 37%,#f1f1f1 63%);background-size:400% 100%;animation:categoryShimmer 1.4s infinite}
    @keyframes categoryShimmer{0%{background-position:100% 0}100%{background-position:-100% 0}}
    @media(max-width:767px){
     .category-section{padding:30px 0 15px}
     .category-head{margin-bottom:20px}
     .category-head h2{font-size:22px}
     .category-head p{font-size:13px}
     .category-image-box{border-radius:11px}
     .category-name{font-size:13px;margin-top:9px}
    }
   `}</style>

            <section className="category-section">
                <Container>
                    <div className="category-head">
                        <div className="small-title">Explore</div>
                        <h2>Shop By Category</h2>
                        <p>Discover our thoughtfully curated collections</p>
                    </div>

                    <Row className="g-3 g-md-4">
                        {loading ?
                            Array.from({ length: 6 }).map((_, index) => (
                                <div key={index} className="col-lg-2 col-sm-3 col-4">
                                    <div className="category-skeleton">
                                        <div className="category-skeleton-img"></div>
                                        <div className="category-skeleton-text"></div>
                                    </div>
                                </div>
                            ))
                            :
                            categoryList.length > 0 ?
                                categoryList.map((category, index) => (
                                    <div key={category.category_id || index} className="col-lg-2 col-sm-3 col-4">
                                        <CategoryItem category={category} />
                                    </div>
                                ))
                                :
                                <div className="col-12">
                                    <h5 className="text-center my-5 text-danger">No products found</h5>
                                </div>
                        }
                    </Row>
                </Container>
            </section>
        </>
    );
};

const CategoryItem = ({ category }) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    return (
        <Link to={`/${category.category_slug}`} className="category-card">
            <div className="category-image-box">
                {!imageLoaded && <div className="category-skeleton-img position-absolute top-0 start-0 w-100 h-100"></div>}
                <img
                    width="370"
                    height="370"
                    src={category.category_thumbnail}
                    alt={`Traditional ${category.category_name} Collection`}
                    className={imageLoaded ? '' : 'd-none'}
                    onLoad={() => setImageLoaded(true)}
                    onError={() => setImageLoaded(true)}
                />
                <div className="category-overlay"></div>
            </div>
            <p className="category-name">
                {category.category_name}
                <span className="category-arrow">→</span>
            </p>
        </Link>
    );
};

export default CategoryComponent;